import React from 'react';

import AddButton from '../../shared/AddButton';

import { itemTypeOptions } from '../../../constants/enums';

const CaseUsageItemRow = (props) => {
  const { label, checklistDescription, description, type, qty, onChange, code } = props;

  return (
    <div className='case-usage-modal__table-row'>
      <div style={{ flex: 0.15 }}>{code}</div>
      <div style={{ flex: 0.15 }}>{label}</div>
      <div style={{ flex: 0.4, paddingLeft: 4 }}>{checklistDescription || description}</div>
      <div style={{ flex: 0.15, paddingLeft: 4 }}>{itemTypeOptions[type]?.label}</div>
      <div
        style={{ flex: 0.15 }}
        className='font-bold d-flex flex-end'
      >
        <AddButton
          variant='remove'
          disabled={qty === 0}
          onClick={() => onChange(qty - 1)}
        />
        <div className='m-l-md m-r-md text-center' style={{ width: 12 }}>{qty}</div>
        <AddButton onClick={() => onChange(qty + 1)} />
      </div>
    </div>
  );
};

export default CaseUsageItemRow;
